import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { debounceTime, filter, share, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { environment } from '../../../environments/environment';

@Directive({
  selector: '[controlResetTimer]',
})
export class ControlResetTimerDirective implements OnInit, OnDestroy {
  @Input() controlResetTimer: () => void;
  @Input() controlResetTimerEmitDebounce = 200;

  @Output() controlResetTimerEmit = new EventEmitter<any>();
  
  private destroy$ = new Subject<void>();
  private readonly controlResetTimeout = 50;

  constructor(private control: NgControl) {}

  ngOnInit() {
    if (!this.control) {
      return;
    }

    const valueChanges$ = this.control.valueChanges
      .pipe(
        filter(value => value !== null && value !== undefined && value !== ''),
        share(),
      );

      valueChanges$
        .pipe(
          debounceTime(this.controlResetTimerEmitDebounce),
          takeUntil(this.destroy$),
        )
        .subscribe(value => this.controlResetTimerEmit.emit(value))

    if (environment.production) {
        valueChanges$
          .pipe(
            debounceTime(this.controlResetTimeout),
            takeUntil(this.destroy$),
          )
          .subscribe(() => {
            if (this.controlResetTimer) {
              this.controlResetTimer();
            } else if (this.control.control) {
              this.control.control.reset(null, {emitEvent: false});
            }
          })
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
